import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { StoreDeliveryFeeConfirmTemplate } from 'components/Templates'

const StoreDeliveryFeeConfirm: FC = () => {
  return (
    <Layout title={'確認 | 配送料設定'}>
      <StoreDeliveryFeeConfirmTemplate />
    </Layout>
  )
}

export default StoreDeliveryFeeConfirm
